import React from "react";

const InviteCouponSectionHeading = ({ label }) => (
  <div
    className="invite-coupon-section-heading text-xs font-semibold uppercase px-3 py-2 border-round-top-md"
    style={{
      background: "color-mix(in srgb, var(--theme-border, #E9ECEF) 55%, transparent)",
      color: "var(--theme-text-muted, #7A869A)",
      letterSpacing: "0.02em",
    }}
  >
    {label}
  </div>
);

export default InviteCouponSectionHeading;
